import { AllowChangeGrid } from '../../../../../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import { AvailabilityEnum } from '../../../../../../../../../products/ProductTypes';
import { Combination } from '../../../../../../../../../products/products-details-v2/components/CombinationLine/types/combinationLine.types';
import { OrderProduct } from '../../../../../../../orderProducts.types';
import { OrderProductGridContextProviderProps } from '../../../../../types/OrderProductGridContext.types';

export type OrderProductGridContainerProps = Omit<OrderProductGridContextProviderProps, 'children'>;

export interface OrderProductForGridContainer {
  productId: string;
  productColorId: string;
  availability: AvailabilityEnum;
  deliveryWindowId?: string;
  productAllowChangePreOrderGrid: AllowChangeGrid;
  productAllowChangeImmediateGrid: AllowChangeGrid;
  combinationKey?: string;
  orderId?: string;
}

export interface FromCatalogParams {
  productId: string;
  productColorId: string;
  availability: AvailabilityEnum;
  deliveryWindowId?: string;
  combinationKey: string;
  orderId?: string;
  allowChangeImmediateGrid: AllowChangeGrid;
  allowChangePreOrderGrid: AllowChangeGrid;
}

export class OrderProductForGridContainerTransformer {
  static fromProductDetails(orderProduct: Combination): OrderProductForGridContainer {
    return {
      productColorId: orderProduct.productColorId,
      availability: orderProduct.availability,
      productId: orderProduct.productId,
      deliveryWindowId:
        orderProduct.futureStockDeliveryWindowId || orderProduct.deliveryWindowId || undefined,
      productAllowChangeImmediateGrid: orderProduct.allowChangeImmediateGrid,
      productAllowChangePreOrderGrid: orderProduct.allowChangePreOrderGrid,
    };
  }

  static fromCatalog({
    productId,
    productColorId,
    availability,
    deliveryWindowId,
    combinationKey,
    orderId,
    allowChangeImmediateGrid,
    allowChangePreOrderGrid,
  }: FromCatalogParams): OrderProductForGridContainer {
    return {
      productId,
      productColorId,
      availability,
      deliveryWindowId,
      combinationKey,
      orderId,
      productAllowChangeImmediateGrid: allowChangeImmediateGrid,
      productAllowChangePreOrderGrid: allowChangePreOrderGrid,
    };
  }

  static fromOrder(product: OrderProduct): OrderProductForGridContainer {
    return {
      availability: product.availability as AvailabilityEnum,
      productColorId: product.productColorId,
      productId: product.productId,
      deliveryWindowId: product.deliveryWindow?.id,
      productAllowChangeImmediateGrid: product.allowChangeImmediateGrid,
      productAllowChangePreOrderGrid: product.allowChangePreOrderGrid,
    };
  }
}
